// Top row displaying day names for the calendar.
import { addDays, startOfWeek, format } from 'date-fns';
import { Box } from '@mui/material';
import {
  getDateFnsLocale,
  getShortWeekdayPattern,
} from '@/i18n/getDateFnsLocale';
import { useCurrentLocale } from '@/i18n/useT';

const WeekdayHeader = () => {
  useCurrentLocale();
  const locale = getDateFnsLocale();
  const pattern = getShortWeekdayPattern();
  const weekDays = Array.from({ length: 7 }, (_, i) => {
    const day = addDays(startOfWeek(new Date(), { weekStartsOn: 1 }), i);
    return format(day, pattern, { locale });
  });

  return (
    <Box
      sx={{
        position: 'sticky',
        top: 0,
        zIndex: 2,
        display: 'grid',
        gridTemplateColumns: 'repeat(7, 1fr)',
        textAlign: 'center',
        fontWeight: 'bold',
        bgcolor: 'grey.100',
        borderBottom: 1,
        borderColor: 'divider',
        p: '8px 0',
      }}
      className="shared-day-header"
    >
      {weekDays.map((dayName) => (
        <Box
          key={dayName}
          sx={{
            p: '4px 0',
            fontSize: '0.72em',
            textTransform: 'uppercase',
            color: 'text.subtle',
          }}
        >
          {dayName}
        </Box>
      ))}
    </Box>
  );
};

export default WeekdayHeader;
